import { type ReactElement } from "react";
import { Text, Box, Divider } from "@citibox-panel/ui";

export function DividerDemo(): ReactElement {
  return (
    <>
      <Text variant="body2">Contenido por encima del divider.</Text>
      <div style={{ margin: "12px 0" }}>
        <Divider />
      </div>
      <Text variant="body2">Contenido por debajo del divider.</Text>
      <Box sx={{ display: "flex", height: 48, gap: 2, marginTop: 2 }}>
        <Text variant="body2">Izquierda</Text>
        <Divider orientation="vertical" flexItem />
        <Text variant="body2">Derecha</Text>
      </Box>
    </>
  );
}
